<template lang="pug">
  main.home#main
    .hero
      img.hero-image(:src='hero_image.url', :alt='hero_image.alt')
      .hero-text-wrapper
        prismic-rich-text(:field='title')
        prismic-rich-text(:field='description')
    section#about
      prismic-rich-text(:field='about')
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      title: null,
      description: null,
      hero_image: '',
      about: null,
      metadata: {
        title: null,
        description: null,
        socialTitle: null,
        socialDescription: null,
        socialImage: null
      }
    }
  },
  metaInfo () {
    return {
      title: this.metadata.title,
      titleTemplate: '%s - Progressive Plant Research',
      meta: [
        { name: 'description', content: this.metadata.description },
        { property: 'og:title', content: this.metadata.socialTitle, template: '%s - Progressive Plant Research' },
        { property: 'og:description', content: this.metadata.socialDescription },
        { property: 'og:image', content: this.metadata.socialImage },
        { name: 'twitter:title', content: this.metadata.socialTitle, template: '%s - Progressive Plant Research' },
        { name: 'twitter:description', content: this.metadata.socialDescription },
        { name: 'twitter:image', content: this.metadata.socialImage }
      ]
    }
  },
  methods: {
    getContent (uid) {
      this.$prismic.client.getSingle('home')
        .then((document) => {
          if (document) {
            this.title = document.data.hero_title
            this.description = document.data.hero_description
            this.hero_image = document.data.hero_image
            this.about = document.data.about
            this.metadata.title = document.data.metadata_title
            this.metadata.description = document.data.metadata_description
            this.metadata.socialTitle = document.data.metadata_social_title
            this.metadata.socialDescription = document.data.metadata_social_description
            this.metadata.socialImage = document.data.metadata_social_image.url
          } else {
            this.$router.push({ name: 'not-found' })
          }
        })
    }
  },
  created () {
    this.getContent(this.$route.params.uid)
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent(to.params.uid)
    next()
  }
}
</script>

<style lang="stylus">
@import '../styles/components/hero.styl'

  #about p
    margin 20px auto
</style>
